@if (iframeSrc) {
  <h1>Blah Blah Blah</h1>
  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur sodales neque ut lectus congue imperdiet.
    Suspendisse ac maximus est, nec bibendum ante. Maecenas sed sapien rutrum, rhoncus felis quis, placerat lacus.
    Quisque vitae vehicula tortor, et porta purus. Quisque pulvinar vitae metus nec laoreet. Integer sodales tempus
    euismod. Donec nec.</p>
  <iframe #iframe></iframe>
  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur sodales neque ut lectus congue imperdiet.
    Suspendisse ac maximus est, nec bibendum ante. Maecenas sed sapien rutrum, rhoncus felis quis, placerat lacus.
    Quisque vitae vehicula tortor, et porta purus. Quisque pulvinar vitae metus nec laoreet. Integer sodales tempus
    euismod. Donec nec.</p>
} @else {
  <div class="column align-stretch game w100">
    <app-game/>

    @if (mobile) {
      <div class="actions row">
        @if (playing()) {
          <button
            type="button"
            class="jump"
            (pointerdown)="onButtonEvent($event, 'game-jump-begin')"
            (click)="$event.stopPropagation()"
            (contextmenu)="$event.preventDefault()"
          >Jump
          </button>
          <button
            type="button"
            class="duck"
            (pointerdown)="onButtonEvent($event, 'game-duck-begin')"
            (pointerup)="onButtonEvent($event, 'game-duck-end')"
            (touchstart)="onButtonEvent($event, 'game-duck-begin')"
            (touchend)="onButtonEvent($event, 'game-duck-end')"
            (click)="$event.stopPropagation()"
            (contextmenu)="$event.preventDefault()"
          >Duck
          </button>
        } @else {
          <button
            type="button"
            class="jump"
            (click)="onButtonEvent($event, 'game-playing')"
            (contextmenu)="$event.preventDefault()"
          >Start!</button>

          @if (experimental) {
            <button
              type="button"
              class="jump"
              (click)="onFullScreen()"
              (contextmenu)="$event.preventDefault()"
            >Full</button>
          }
        }
      </div>
    } @else {
      <div class="instructions" [innerHTML]="instructions()"></div>
    }
  </div>

  <!-- PRESETS -->
  <div class="presets row w100">
    @for ($preset of config.presets; track $preset.name) {
      <button
        type="button"
        (click)="config.setPreset($preset)"
        [class.disabled]="playing()"
        [disabled]="playing()"
      >{{ $preset.name }}
      </button>
    }
  </div>

  <!-- SETTING SLIDERS -->
  <div class="controls">
    <div>
      Delay
    </div>
    <div>
      <app-slider
        [(value)]="config.latency"
        [maxValue]="config.config.maxActionLatency"
        [step]="100"
        [disabled]="playing()"
      />
    </div>
    <div>
      {{ config.latency() }}ms
    </div>
    @if (!config.config.fogDisabled) {
      <div>
        Visibility
      </div>
      <div>
        <app-slider [(value)]="reverseLookAhead" [maxValue]="config.maxLookAhead" [disabled]="playing()"/>
      </div>
      <div>
        {{ config.lookAhead() / config.maxLookAhead / 2 + 0.5 | percent: '.0' }}
      </div>
    }
    <div>
      Errors
    </div>
    <div>
      <app-slider [(value)]="config.errorRate" [maxValue]="100" [step]="10" [disabled]="playing()"/>
    </div>
    <div>
      {{ config.errorRate() }}%
    </div>
    @if (showSpeed) {
      <div>
        Speed
      </div>
      <div>
        <app-slider [(value)]="config.speed" [maxValue]="9" [disabled]="playing()"/>
      </div>
      <div>
        {{ config.speed() + 1 }}
      </div>
    }
  </div>

  <!-- OVERLAY WHEN WE DON'T HAVE KEYBOARD FOCUS -->
  <div
    class="message overlay row"
    [class.hidden]="appHasFocus()"
    tabindex="-1"
    (click)="$event.stopPropagation(); $event.preventDefault()">
    <div class="message-text">Click here to play!</div>
  </div>
}
